// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"5f2de45e","425":"dc1a36d4","453":"f73ccd17","590":"cf1a262d","760":"8e7b0247","850":"507c37fe"}[chunkId] + ".chunk.js";
};